import types from '../type/types.js'

export const setWireLength = length => ({
    type: types.SET_WIRE_LENGTH,
    payload: length
  })

  export default {}